var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "policy" },
    [
      _c(
        "basic-container",
        [
          [
            _c(
              "el-row",
              { attrs: { span: 24 } },
              [
                _c(
                  "el-col",
                  { attrs: { md: 24, sm: 24, xs: 24 } },
                  [
                    _c("avue-crud", {
                      ref: "crud",
                      attrs: {
                        data: _vm.tableData,
                        option: _vm.tableOption,
                        page: _vm.page,
                        "summary-method": _vm.summaryMethod,
                        "table-loading": _vm.tableLoading,
                      },
                      on: {
                        "update:page": function ($event) {
                          _vm.page = $event
                        },
                        "on-load": _vm.toList,
                        "search-change": _vm.searchChange,
                        "search-reset": _vm.searchReset,
                        "refresh-change": _vm.refreshChange,
                        "size-change": _vm.sizeChange,
                        "current-change": _vm.currentChange,
                        "row-update": _vm.handleUpdate,
                        "row-save": _vm.handleSave,
                        "row-del": _vm.rowDel,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "menuLeft",
                          fn: function (ref) {
                            var size = ref.size
                            return [
                              _c(
                                "el-radio-group",
                                {
                                  on: { change: _vm.statusChange },
                                  model: {
                                    value: _vm.searchForm.status,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.searchForm, "status", $$v)
                                    },
                                    expression: "searchForm.status",
                                  },
                                },
                                _vm._l(_vm.statusButtons, function (button) {
                                  return _c(
                                    "el-radio-button",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            !button.condition ||
                                            button.condition(),
                                          expression:
                                            "!button.condition || button.condition()",
                                        },
                                      ],
                                      key: button.label,
                                      attrs: {
                                        size: size,
                                        label: button.label,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t\t" +
                                          _vm._s(button.text) +
                                          "\n\t\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                }),
                                1
                              ),
                              _vm.isShowMoreInsured
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "30px" },
                                      attrs: {
                                        icon: "el-icon-plus",
                                        type: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onToMoreInsured(
                                            "editMoreInsured"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t批量更改被保险人\n\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isShowMoreInsured
                                ? _c(
                                    "el-button",
                                    {
                                      staticStyle: { "margin-left": "20px" },
                                      attrs: {
                                        icon: "el-icon-plus",
                                        type: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onToMoreInsured(
                                            "addMoreInsured"
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t批量增加被保险人\n\t\t\t\t\t\t\t"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                        {
                          key: "menu",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm.searchForm.status == -2
                                ? [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "u-row-center",
                                        staticStyle: { width: "100%" },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-view",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleViewSurrender(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-view",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleView(row)
                                              },
                                            },
                                          },
                                          [_vm._v("保单详情")]
                                        ),
                                        row.btn && row.btn.submitMaterial
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleSubmitMaterials(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t提交材料\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        row.btn && row.btn.addMaterial
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleSupplementMaterials(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t补传材料\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        row.btn && row.btn.addExpressNo
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-upload",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleSubmitExpressNo(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t上传快递单号\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        row.btn && row.btn.showEndorse
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  icon: "el-icon-view",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleViewSurrenderDocs(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t查看电子批单\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                  ]
                                : _vm.searchForm.status == 999
                                ? [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "100%" } },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              loading: _vm.isShowLoading,
                                              icon: "el-icon-edit",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEditStaging(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t编辑\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              disabled: _vm.isStagingDeleting,
                                              icon: "el-icon-delete",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleDeleteStaging(
                                                  row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t\t删除\n\t\t\t\t\t\t\t\t\t"
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                : [
                                    _c(
                                      "div",
                                      { staticStyle: { width: "180px" } },
                                      [
                                        _vm.searchForm.status == 0 &&
                                        (row.redpackStatus === "RECEIVED" ||
                                          row.redpackStatus ===
                                            "WAIT_RECEIVE" ||
                                          row.redpackStatus === "WAIT_CONFIRM")
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "u-flex u-row-center u-col-center",
                                                staticStyle: {
                                                  cursor: "pointer",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onGetRedPacketCode(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    staticClass: "icon-test",
                                                    attrs: {
                                                      "aria-hidden": "true",
                                                    },
                                                  },
                                                  [
                                                    _c("use", {
                                                      attrs: {
                                                        "xlink:href":
                                                          "#icon-hongbao",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                row.redpackStatus ===
                                                "WAIT_RECEIVE"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "u-font-weight-bold",
                                                        staticStyle: {
                                                          color: "#409eff",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t领取红包\n\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : row.redpackStatus ===
                                                    "RECEIVED"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "u-font-weight-bold",
                                                        staticStyle: {
                                                          color: "#b0b0b0",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t已领取红包\n\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "u-font-weight-bold",
                                                      },
                                                      [_vm._v("刷新红包")]
                                                    ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              icon: "el-icon-view",
                                              type: "text",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleView(row)
                                              },
                                            },
                                          },
                                          [_vm._v("查看")]
                                        ),
                                        _vm.searchForm.status == 1
                                          ? _c("pay-btn", {
                                              attrs: {
                                                "pay-btn-data-temp":
                                                  _vm.getOrderData(row),
                                              },
                                              on: {
                                                onPayOffLineSuccess:
                                                  _vm.onPayOffLineSuccess,
                                                onToOfflinePay:
                                                  _vm.onToOfflinePay,
                                              },
                                            })
                                          : _vm._e(),
                                        _vm.searchForm.status == 0 &&
                                        row.allowSpecEndorse
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  loading: _vm.isShowLoading,
                                                  icon: "el-icon-plus",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onAddInsured(
                                                      row,
                                                      _vm.EnumInsureUrlType
                                                        .addInsured
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t新增被保险人\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm.searchForm.status == 0 &&
                                        row.allowCoinsuredEndorse
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  loading: _vm.isShowLoading,
                                                  icon: "el-icon-edit",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.onAddInsured(
                                                      row,
                                                      _vm.EnumInsureUrlType
                                                        .editSingleInsured
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t更改被保险人\n\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        (_vm.searchForm.status == 2 ||
                                          _vm.searchForm.status == 3) &&
                                        row.repurchase &&
                                        row.renewFlag
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "u-flex u-row-center u-col-center",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.judgeHandleRe(
                                                          row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "svg",
                                                      {
                                                        staticClass:
                                                          "icon-test",
                                                        attrs: {
                                                          "aria-hidden": "true",
                                                        },
                                                      },
                                                      [
                                                        _c("use", {
                                                          attrs: {
                                                            "xlink:href":
                                                              "#icon-hongbao",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "u-font-weight-bold",
                                                        staticStyle: {
                                                          color: "#409eff",
                                                        },
                                                      },
                                                      [_vm._v("出单有惊喜")]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      loading:
                                                        _vm.isShowLoading,
                                                      icon: "el-icon-edit",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.judgeHandleRe(
                                                          row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t续保\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      loading:
                                                        _vm.isShowLoading,
                                                      icon: "el-icon-edit",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.judgeHandleRe(
                                                          row,
                                                          3
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t计划书\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            )
                                          : (_vm.searchForm.status == 5 ||
                                              _vm.searchForm.status == 0 ||
                                              _vm.searchForm.status == 2 ||
                                              _vm.searchForm.status == 3) &&
                                            row.renewFlag
                                          ? _c(
                                              "div",
                                              [
                                                _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      loading:
                                                        _vm.isShowLoading,
                                                      icon: "el-icon-edit",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.judgeHandleRe(
                                                          row,
                                                          2
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t续保\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                                !_vm.isJiaDian(row.insureType)
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          icon: "el-icon-edit",
                                                          type: "text",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.judgeHandleRe(
                                                              row,
                                                              3
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t计划书\n\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "u-flex u-row-center",
                                              },
                                              [
                                                !_vm.isRenBao(row.insureType) &&
                                                (_vm.searchForm.status == 1 ||
                                                  _vm.searchForm.status == -1 ||
                                                  _vm.searchForm.status == 8 ||
                                                  (_vm.searchForm.status ==
                                                    100 &&
                                                    row.status == 102) ||
                                                  (_vm.searchForm.status == 3 &&
                                                    row.status == 5))
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          icon: "el-icon-edit",
                                                          type: "text",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.judgeHandleRe(
                                                              row,
                                                              1
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t重新提交\n\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.isRenBao(row.insureType) &&
                                                _vm.searchForm.status == 1
                                                  ? _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          loading:
                                                            _vm.isShowLoading,
                                                          icon: "el-icon-close",
                                                          type: "text",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.onCancelPolicy(
                                                              row
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t取消\n\t\t\t\t\t\t\t\t\t\t"
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                        _c(
                                          "div",
                                          [
                                            _vm.searchForm.status == 1 &&
                                            _vm.isDownloadPayFile(
                                              row.insureType
                                            )
                                              ? _c(
                                                  "el-button",
                                                  {
                                                    attrs: {
                                                      loading:
                                                        _vm.isShowLoading,
                                                      icon: "el-icon-download",
                                                      type: "text",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.onDownloadPayFile(
                                                          row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t\t下载缴费通知书\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          _c(
            "el-dialog",
            {
              staticClass: "avue-dialog avue-dialog--top",
              attrs: {
                visible: _vm.dialogExpressVisible,
                center: "",
                title: "上传快递单号",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogExpressVisible = $event
                },
              },
            },
            [
              _c("avue-form", {
                attrs: { option: _vm.optionExpress },
                on: { submit: _vm.handleTrackingNumberUpload },
                model: {
                  value: _vm.formExpress,
                  callback: function ($$v) {
                    _vm.formExpress = $$v
                  },
                  expression: "formExpress",
                },
              }),
            ],
            1
          ),
          _c("product-choice", {
            attrs: {
              isShowProductChoiceTemp: _vm.isShowProductChoice,
              "product-list": _vm.productList,
            },
            on: {
              onClickClose: _vm.onClickClose,
              onClickInsure: _vm.onClickInsure,
            },
          }),
          _c("insure-notices", {
            ref: "refInsureNotices",
            on: { onToInsure: _vm.onAgreeInsure, onToSure: _vm.onAgreeInsure },
          }),
          _c("PayOffLineDialog", { ref: "refPayDialog" }),
          _c("show-pdf-dialog", { ref: "refPdf" }),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.isShowQrCode,
                center: "",
                title: "微信扫一扫，有惊喜降临",
                width: "30%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.isShowQrCode = $event
                },
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "u-flex u-row-center",
                  staticStyle: { padding: "0 20px" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "data:image/png;base64," + _vm.qrCodeUrl,
                      alt: "",
                    },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "u-flex u-row-center",
                  staticStyle: { "margin-top": "30px" },
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        loading: _vm.isShowLoading,
                        icon: "el-icon-refresh",
                        type: "primary",
                      },
                      on: { click: _vm.onRefreshCode },
                    },
                    [_vm._v("\n\t\t\t\t\t刷新小程序码\n\t\t\t\t")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }